<template>
  <div class="appContainer my-code top_container">
    <div class="title">
      <div class="line"></div>
      <h1>
        {{ $t('company-code.header', { split: '/' }) }}
      </h1>
    </div>
    <div class="rc-top">
      <div class="rc-container">
        <div class="code-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCode'
};
</script>

<style lang="scss" scoped>
@import './companyCode.scss';
</style>
